import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Navbar from './components/layout/Navbar';
import Leaderboard from './components/pages/Leaderboard';
import PlayerList from './components/pages/PlayerList';
import TeamGenerator from './components/pages/TeamGenerator';
import PlayerStatUpload from './components/pages/PlayerStatUpload';
import LoginPage from './components/pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import SkillSuggestion from './components/pages/SkillSuggestion';
import HomePage from './components/pages/HomePage';


const App = () => {

  return (
    <DndProvider backend={HTML5Backend}>
      <Router>
        <div>
          <Navbar />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/skillsuggestion" element={<SkillSuggestion />} />
            <Route path="/players" element={<ProtectedRoute><PlayerList /></ProtectedRoute>} />
            <Route path="/team-generator" element={<TeamGenerator />} />
            <Route path="/stat-upload" element={<ProtectedRoute><PlayerStatUpload /></ProtectedRoute>} />
            <Route path="/" element={<HomePage />} />
          </Routes>
        </div>
      </Router>
    </DndProvider>
  );
};

export default App;
